import { render, staticRenderFns } from "./SuccessButton.vue?vue&type=template&id=61c42d12&"
import script from "./SuccessButton.vue?vue&type=script&lang=js&"
export * from "./SuccessButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports